import { ScreenHeader } from '@/components/layout/screen-header';
import { useRouter } from 'expo-router';
import { ActivityIndicator, ScrollView, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useAppTheme } from '@/providers/theme-provider';
import { AdminDashboardCard } from '../components/admin-dashboard-card';
import { useAdminListUsers } from '../hooks/use-admin-users';
import { useAdminPendingMenuItems } from '../hooks/use-admin-menu-items';
import { useAdminPendingBusinesses } from '../hooks/use-admin-businesses';
import { useAdminInviteStats } from '../hooks/use-admin-invites';

export function AdminDashboardScreen() {
  const theme = useAppTheme();
  const router = useRouter();

  const { data: usersData, isLoading: usersLoading } = useAdminListUsers({ perPage: 1 });
  const { data: pendingItemsData, isLoading: pendingItemsLoading } = useAdminPendingMenuItems({ per_page: 1 });
  const { data: pendingBizData, isLoading: pendingBizLoading } = useAdminPendingBusinesses({ per_page: 1 });
  const { data: inviteStatsData, isLoading: inviteStatsLoading } = useAdminInviteStats();

  const totalUsers = usersData?.total ?? undefined;
  const pendingItemCount = pendingItemsData?.total ?? undefined;
  const pendingBizCount = pendingBizData?.total ?? undefined;
  const activeInviteCount = inviteStatsData?.active ?? undefined;
  const isLoading = usersLoading || pendingItemsLoading || pendingBizLoading || inviteStatsLoading;

  const totalPending = (pendingItemCount ?? 0) + (pendingBizCount ?? 0);

  return (
    <SafeAreaView className="flex-1 bg-background">
      <ScrollView
        className="flex-1"
        showsVerticalScrollIndicator={false}
        contentContainerClassName="px-4 pb-8"
      >
        <ScreenHeader title="Admin Portal" showBackButton />

        {isLoading && (
          <View style={{ paddingVertical: 24, alignItems: 'center' }}>
            <ActivityIndicator color={theme.colors.primary} />
          </View>
        )}

        <View style={{ marginTop: 8 }}>
          <AdminDashboardCard
            icon="people-outline"
            title="User Management"
            subtitle="Manage users, roles, and bans"
            count={totalUsers}
            onPress={() => router.push('/(root)/admin/users')}
          />
          <AdminDashboardCard
            icon="restaurant-outline"
            title="Pending Menu Items"
            subtitle="Review and approve submissions"
            count={pendingItemCount}
            onPress={() => router.push('/(root)/admin/pending-items')}
          />
          <AdminDashboardCard
            icon="storefront-outline"
            title="Pending Businesses"
            subtitle="Review and approve restaurant suggestions"
            count={pendingBizCount}
            onPress={() => router.push('/(root)/admin/pending-businesses')}
          />
          <AdminDashboardCard
            icon="mail-outline"
            title="Invite Codes"
            subtitle="Create and manage invite codes"
            count={activeInviteCount}
            onPress={() => router.push('/(root)/admin/invites')}
          />
        </View>

        {!isLoading && totalPending > 0 && (
          <View
            className="bg-surface"
            style={{ borderRadius: 12, padding: 14, marginTop: 8 }}
          >
            <Text className="text-muted-foreground" style={{ fontSize: 13 }}>
              {totalPending} item{totalPending !== 1 ? 's' : ''} awaiting review
            </Text>
          </View>
        )}
      </ScrollView>
    </SafeAreaView>
  );
}
